// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import Iconify from '../../../components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';
// ----------------------------------------------------------------------
const ICON_SIZE = {
  width: 22,
  height: 22,

};
const event = [

// {
//   "id": '7d79aa02-9d6c-4359-9574-7ed096b30d36',
//   "title": "Revival Fasting Prayer",
//   "subtitle": "",
//   "category": "Camp",
//   "detail1": "June 21st 2025",
//   "detail2": "Essex, London, UK",
//   "detail3": "",
//   "detail4": "07900817242, 07919717222",
//   "url": "",
//   "imageUrl": "/assets/RFP_UK.jpg",
//   "videoUrl": "",
//   "liveUrl": ""
// },
{
  "id": 'a6c8a62e-cbb9-411c-93bc-975e01f2c191',
  "title": "Revival Prayer Conference",
  "subtitle": "only for Telugu Pastors",
  "category": "Camp",
  "detail1": "June 25 - 27, 2025",
  "detail2": "Tabernacle of God, Nalumavadi & Prayer Mountain, Tenkasi",
  "detail3": "",
  "detail4": "+91 88856 03006, +91 87121 23958",
  "url": "",
  "imageUrl": "/assets/RPC.jpg",
  "videoUrl": "",
  "liveUrl": ""
},
{
      "id": '3dcb6e1b-4904-4371-a1d7-acca761aebdf',
      "title": "Washington DC Standing in the Gap",
      "subtitle": '',
      "category": "Camp",
      "detail1": "July 3-5, 2025",
      "detail2": "Prince of Peace Luthran Church, VA",
      "detail3": '',
      "detail4": "jrusa@jesusredeems.org",
      "startDayAndTime": "Tue, Jun 10 2025 12:30 AM",
      "endDayAndTime": "Thu, Jul 03 2025 12:30 AM",
      "url": '',
      "imageUrl": '/assets/SITGDC.jpg',
      "videoUrl": '',
      "liveUrl": '',
    },
       {
      "id": '5395c339-a9d6-4cfd-b7a8-b611d0399ce7',
      "title": "Las Vegas USA Standing in the Gap",
      "subtitle": '',
      "category": "Camp",
      "detail1": "July 10-12, 2025",
      "detail2": "Trinity Life Center, Las Vages, NV",
      "detail3": '',
      "detail4": "jrusa@jesusredeems.org",
      "startDayAndTime": "Tue, Jun 10 2025 12:30 AM",
      "endDayAndTime": "Thu, Jul 10 2025 12:30 AM",
      "url": '',
      "imageUrl": '/assets/SITGLV.jpg',
      "videoUrl": '',
      "liveUrl": '' ,
    },
    {
      "id": 'cb29c3f6-b038-44c1-bd78-9fd824bcf1f6',
      "title": "Houston TX Standing in the Gap",
      "subtitle": '',
      "category": "Camp",
      "detail1": "July 19, 2025",
      "detail2": "Grace Center, Richmond, TX",
      "detail3": '',
      "detail4": "jrusa@jesusredeems.org",
      "startDayAndTime": "Tue, Jun 10 2025 12:30 AM",
      "endDayAndTime": "Thu, Jul 10 2025 12:30 AM",
      "url": '',
      "imageUrl": '/assets/SITGHN.jpg',
      "videoUrl": '',
      "liveUrl": '' ,
    },
]

const dynamicChildren = event.map(f => ({
  title: f.title,
  path: `/dashboard/event/${f.id}/enroll`
}));
const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;
const getIcons = (name) => <Iconify icon={`${name}`} {...ICON_SIZE} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
};

const navConfig = [
  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.general.myapp,
        icon: ICONS.dashboard,
      },

      // children:[
      //   { title: 'Event management', path: PATH_DASHBOARD.general.eventmgmt },
      // ]
      // },
    ],
  },
 {
    items: [
      // Events
      {
        title: 'Events',
        icon: <Iconify icon={'icon-park-outline:bless'} {...ICON_SIZE} />,
        children: [
        //  { title: 'Revival Festivals', path: PATH_DASHBOARD.events.rf25 },
          { title: 'WR Vision Camp', path: PATH_DASHBOARD.events.wrvc },
       //   { title: 'Truth Widow', path: PATH_DASHBOARD.events.twr },
       ...dynamicChildren // Add your mapped dynamic entries here
          
        ],
      },
    ],
  },
  // {
  //   items: [
  //     // Blessing Plan
  //     {
  //       title: 'Prayer Plan',
  //       icon: <Iconify icon={'icon-park-outline:bless'} {...ICON_SIZE} />,
  //       children: [
  //         { title: 'Family Blessing', path: PATH_DASHBOARD.plan.fbp },
  //         { title: 'Business Blessing', path: PATH_DASHBOARD.plan.bbp },
  //         { title: 'Children Blessing', path: PATH_DASHBOARD.plan.cbp },
  //         { title: 'Youth Blessing', path: PATH_DASHBOARD.plan.foj },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   items: [
  //     // Revival Plan
  //     {
  //       title: 'Revival Plan',
  //       icon: <Iconify icon={'mdi:fire'} {...ICON_SIZE} />,
  //       children: [
  //         { title: 'Prayer Partner(RPP)', path: PATH_DASHBOARD.revival.rpp },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   items: [
  //     // Magazine Subscription
  //     {
  //       title: 'Magazine',
  //       icon: (
  //         <Iconify
  //           icon={'material-symbols:menu-book-outline-sharp'}
  //           {...ICON_SIZE}
  //         />
  //       ),
  //       children: [
  //         { title: 'JR Main', path: PATH_DASHBOARD.magazine.jrmag },
  //         { title: 'Kids', path: PATH_DASHBOARD.magazine.sjmmag },
  //         { title: 'Youth', path: PATH_DASHBOARD.magazine.vumag },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   items: [
  //     // Magazine Subscription
  //     {
  //       title: 'Forms',
  //       icon: (
  //         <Iconify
  //           icon={'material-symbols:menu-book-outline-sharp'}
  //           {...ICON_SIZE}
  //         />
  //       ),
  //       children: [
  //         {
  //           title: 'Dailybible',
  //           path: PATH_DASHBOARD.forms.addbibleverse,
  //         },
  //         {
  //           title: 'Video Feed',
  //           path: PATH_DASHBOARD.forms.addvideofeed,
  //         },

  //         {
  //           title: 'Events',
  //           path: PATH_DASHBOARD.forms.addevents,
  //         },
  //         {
  //           title: 'Magazine',
  //           path: PATH_DASHBOARD.forms.addmagazine,
  //         },
  //         {
  //           title: 'Resources',
  //           path: PATH_DASHBOARD.forms.addresources,
  //         },
  //         {
  //           title: 'Branches',
  //           path: PATH_DASHBOARD.forms.addbranch,
  //         },
  //       ],
  //     },
  //   ],
  // },
  // { items:[{title: 'invoice',
  // path: PATH_DASHBOARD.invoice.root,
  // icon: ICONS.invoice,
  // children: [
  //   { title: 'list', path: PATH_DASHBOARD.invoice.list },
  //   { title: 'details', path: PATH_DASHBOARD.invoice.demoView },
  //   { title: 'create', path: PATH_DASHBOARD.invoice.new },
  //   { title: 'edit', path: PATH_DASHBOARD.invoice.demoEdit },
  // ],}]

  // },

  // ----------------------------------------------------------------------

  // {
  //   subheader : 'Main Menu',
  //   items: [

  //   {
  //     title: 'Events',
  //     icon: <Iconify icon={'material-symbols:event-available-sharp'} {...ICON_SIZE} />,
  //     path: PATH_DASHBOARD.mainmenu.events,
  //   },
  //   {
  //     title: 'Branches',
  //     icon: <Iconify icon={'material-symbols:location-on-outline-rounded'} {...ICON_SIZE} />,
  //     path: PATH_DASHBOARD.mainmenu.gpc,
  //   },
  //   {
  //     title: 'JR Shop',
  //     icon: <Iconify icon={'ic:outline-local-grocery-store'} {...ICON_SIZE} />,
  //     path: 'https://www.jrbibleworld.com/',
  //   },
  // ],

  // },
];

export default navConfig;
